var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKaak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_1309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.53 71.1C5.45 71.27 -3.31 57.17 4.13 36.63C11.56 16.09 30.62 1.75999 50.71 1.59999",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.26 1.49999C68.34 1.32999 77.1 15.43 69.66 35.97C62.22 56.5 43.17 70.84 23.08 71",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.222 28.0465C60.4862 23.753 62.5042 17.5142 59.7292 14.1117C56.9541 10.7092 50.437 11.4314 45.1727 15.7248C39.9084 20.0183 37.8905 26.2571 40.6655 29.6596C43.4405 33.0621 49.9577 32.3399 55.222 28.0465Z",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.84 50.15C29.7623 50.15 30.51 49.4605 30.51 48.61C30.51 47.7595 29.7623 47.07 28.84 47.07C27.9177 47.07 27.17 47.7595 27.17 48.61C27.17 49.4605 27.9177 50.15 28.84 50.15Z",
    fill: "#075E76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 57.04C20.4444 57.04 21.21 56.2744 21.21 55.33C21.21 54.3856 20.4444 53.62 19.5 53.62C18.5556 53.62 17.79 54.3856 17.79 55.33C17.79 56.2744 18.5556 57.04 19.5 57.04Z",
    fill: "#075E76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.06 54.11C40.0044 54.11 40.77 53.3444 40.77 52.4C40.77 51.4556 40.0044 50.69 39.06 50.69C38.1156 50.69 37.35 51.4556 37.35 52.4C37.35 53.3444 38.1156 54.11 39.06 54.11Z",
    fill: "#075E76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.48 45.64C17.4244 45.64 18.19 44.8744 18.19 43.93C18.19 42.9856 17.4244 42.22 16.48 42.22C15.5356 42.22 14.77 42.9856 14.77 43.93C14.77 44.8744 15.5356 45.64 16.48 45.64Z",
    fill: "#075E76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.17 38.49C28.1144 38.49 28.88 37.7244 28.88 36.78C28.88 35.8356 28.1144 35.07 27.17 35.07C26.2256 35.07 25.46 35.8356 25.46 36.78C25.46 37.7244 26.2256 38.49 27.17 38.49Z",
    fill: "#075E76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.76 28.06C24.7044 28.06 25.47 27.2944 25.47 26.35C25.47 25.4056 24.7044 24.64 23.76 24.64C22.8156 24.64 22.05 25.4056 22.05 26.35C22.05 27.2944 22.8156 28.06 23.76 28.06Z",
    fill: "#075E76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.41 44.65C43.625 44.65 44.61 43.665 44.61 42.45C44.61 41.235 43.625 40.25 42.41 40.25C41.195 40.25 40.21 41.235 40.21 42.45C40.21 43.665 41.195 44.65 42.41 44.65Z",
    fill: "#075E76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.52 64.38C30.6025 64.38 31.48 63.5025 31.48 62.42C31.48 61.3375 30.6025 60.46 29.52 60.46C28.4375 60.46 27.56 61.3375 27.56 62.42C27.56 63.5025 28.4375 64.38 29.52 64.38Z",
    fill: "#075E76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_1309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73.79,
    height: 72.6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaak);
export default __webpack_public_path__ + "static/media/kaak.01f3ed4a4b4721910a56b10bac3c1f34.svg";
export { ForwardRef as ReactComponent };